// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3BBml","signatureBlock":"Footer_signatureBlock__1200o","signature":"Footer_signature__1KJyh"};